module.exports = __webpack_public_path__ + "img/rabbit.45637b22.svg";